import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth81: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '38.4 118.5 36.6 114.8 33.2 107.9 33 98.6 33.7 94.5 35.5 89.7 40.9 83 158.5 83 162.8 85.9 167 89.3 170.3 92.7 170.3 106.2 168.5 111.4 166.4 115.8 164 118.5 38.4 118.5',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M150.3,76.1c-29.3,36.3,2.5,55.7,2.5,55.7l2.4-2.7,2.2-2.1,2.8-3.2,3.8-5.3,2.4-2.7,2.1-4.4,1.8-5.2v-13.5s-3.4-3.5-3.4-3.5l-4.1-3.3-4.3-2.9-8.2-7h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M53.4,75.1c32.7,27.5-4.8,56.4-4.8,56.4l-5.3-5.2-4.9-7.6-5.2-10.6-.2-9.4.7-4.3,1.8-4.7,5.4-6.7,4.5-4,4.7-2.9,3.2-1.2v.2Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M169.6,95l1,4.2-.4,7.2-2.4,6.2-4.6,7.5-5.2,7.3-10.8,9.7-8.1,4.4-12.9,4.1-17.4,3.8s-13.6,0-13.6-.1h-2s-14.8-4.1-14.8-4.1l-15.7-5.3-10.1-5-7.2-5.9-6-7.8-3.9-7.2s-2-7.7-2.1-7.7v-11.2c75.5,30.3,136.3,0,136.3,0h-.1Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M169.7,95c-70.1,31.4-136.3,0-136.3,0l1.8-4.3,2.2-3.7,3.2-3.8,4.8-4.4,7.9-3.9,9.4-3.8,7.7-6.4,9.3-7.7,8.8-6.4,5.3-3.5,4.5-1.1h7.7s2.8,1,2.8,1l5.9,3.4,11.9,8,17.9,13.7,12.6,10,10.6,7.9,2,5.1h0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M144.9,137.8c-8.4,5.5-37.5,12.7-45.9,11.7-9.8-1.2-19-4.1-28.2-7.5s-11-3.1-15.8-6.2c-9.1-5.7-15.5-14.4-19.6-24.1s-2.2-20.2,5.3-28.4c5.5-6.1,13.8-7.8,20.9-12l26.6-20.2c21.2-16.1,40.5,13,62.1,24.5,4.7,5.7,10.5,9.5,16.8,13.2,10.4,16.1-7.1,39.1-22,48.8Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M43.5,443.9l1.4,7.1,2.1,7,5.5,7.2,10,3,28.5,1.1,27.7-.4,17.9-1.2,18.9-.6,4.3-.6,3.8-1.6,3.7-3,2.5-3.6s.2-3.8,0-3.8v-11.5c0,.5-126.4.9-126.4.9Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M168.7,422.4l-5.5-39.3c-51.8,27.6,5.5,39.3,5.5,39.3Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M43.6,422.3l5.4-39.8c48.7,23.3-5.4,39.8-5.4,39.8Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M121.1,372A15.6,15.6 0 1 0 89.9,372A15.6,15.6 0 1 0 121.1,372Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M61.6,325.7l1.9-13c47.4-24.2,81.7,0,81.7,0l3,14c-41.2-33.7-86.6-1-86.6-1Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M126.4,468.5s-.2-118.8,26.1-127.3l6.3,18.7,4.3,23.3,2.9,18.7,2.6,20.5s1.2,20.7,1.1,20.7v15.3s-2.5,3.6-2.5,3.6l-3.3,3-4.1,1.6-4.9.8-28.3,1.1h-.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M88.6,469.4l-26.1-1.1-10-3-5.5-7.2-3.5-14.2-.5-18.3.6-3.3,5.4-39.8,1.7-12.1,5.5-19.5,1.9-8.7c26.3,5.9,30.5,127.2,30.5,127.2Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M155.3,467.2l-36.3,1.9-30.6.4-26.1-1.1-10-3-5.5-7.2-3.5-14.2-.5-18.3,7.7-55.2,7.4-28.2,3.5-16.5c50.1-32.6,86.5.6,86.5.6l4.5,14.7,6.3,18.7,4.3,23.2,2.9,18.8,2.6,20.5,1.3,20.6.2,11.7-.3,3.7-2.5,3.6-3.3,3-4.1,1.6-4.3.6h-.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M141.8,467.3l-21.8,1.7c-10.3.8-19.8,1-30,.1-18.6-1.6-37.9,2.9-43-12.1s-4.7-24.3-2.8-37l7.3-49.8c1.8-11.9,6.7-22.6,8-34.7,7.5-9.1,15.8-16.5,26.1-21.8,23.1-11.9,45.5-3.7,63,14.8,2,8.9,5.8,16.8,8.1,25.6l3.8,15.2c3.8,22.2,6.4,44,8.7,66.4s1.2,15.4-.4,23-19.9,8-26.9,8.5Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M72.7,118.8h62.5c-32.7,128.7-62.5,0-62.5,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.1,94.2l-3.3-18.3.8-15.8c52.5,12.7,2.5,34.1,2.5,34.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M164,94l1-34.6c-51.7,14.7-1,34.6-1,34.6Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '36.6 49.4 37.3 45.6 38.6 42.1 44.7 37.2 49.6 35 56.1 33.8 68.5 32.1 81.3 30.7 92.3 29.3 104.2 29.5 119.7 30.4 145 31.5 151.1 32.8 156.2 33.9 160.7 37.1 163.8 41.3 164.8 48.7 36.6 49.4',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148.6,182.4c-55.6,48.3-88.5,0-88.5,0l-3.5-16.8c46.4,59.1,95,0,95,0,0,0-3,16.8-3,16.8Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M157,147.5c-22.2-13.2-37.2-117.2-37.2-117.2l25.3,1.1,10.9,2.3,4.8,3.3,3,4.3,1,7.4.2,10.7-1,34.6-1,14.5-.8,8.2-2,13.8-3.3,17.1h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.5,42l6.1-4.9,5-2.2,7.2-1.3,21.1-2.4s-3.4,106.9-28,116.7l-3.9-13.3-7.9-40.4-3.3-18.3.9-15.8v-4.4s.9-6.3.9-6.3l2-7.3h-.1Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M152,165.7c-52.8,60.7-95,0-95,0l-6.7-17.7-3.9-13.3-11.1-58.3v-2s.8-14.2.8-14.2v-4.4s.9-6.2.9-6.2l.8-3.9,1.2-3.5,6-4.9,5-2.2,7.2-1.3s35.3-4.3,35.3-4.2h12.2s40.6,2,40.6,2l11.3,2.4,4.4,3.1,3,4.3,1.2,7.1-.2,4.7v14.6s-.3,10.4-.3,10.4l-.2,6.6-.5,11.2-.4,5-1.3,15.7-2,13.8-3.3,17.1-5.4,18h.4Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M153.3,158c-15.7,27.4-42.7,50.4-71.3,30.8-11.3-7.8-19.5-18.2-27-30.1-4.7-10.3-7.9-21.2-10.1-32.6l-7.8-40.2c-2.7-13.8-3-28,1.4-41.4,2.1-6.6,10-9.8,16.3-10.4l21.8-2.2c8.5-.9,16.7-2.8,25.4-2.3l33.8,2.1c11.9.7,26.8-.4,28.1,13.4,2.1,23.1-.5,58.3-3.5,82.6-1.3,10.5-3.5,19.9-7.1,30.4Z',
			},
		},
	},
};
